import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import { useSelector } from "react-redux";

const Footer = () => {
  const navigate = useNavigate();
  const userType = useSelector((state) => state.auth?.user?.user?.user_type);
  const salesPerson = useSelector(
    (state) => state.userProfile?.data?.sales_person
  );
  const { items, loading, error } = useSelector((state) => state.collection);

  return (
    <footer className="bg-gray-800 text-white px-2 py-10 text-sm md:text-base text-center lg:text-left">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg-items-start">
        {/* Categories */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Categories</h4>
          {items?.length > 0 &&
            items.map((category) => (
              <div key={category.cat_name} className="flex flex-col mb-2">
                <Link to={`/collections/${category.cat_name}`}>
                  {category.cat_name}
                </Link>
              </div>
            ))}
        </div>

        {/*  */}
        {/* Social Presence */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Our Social Presence</h4>
          <ul className="space-y-2">
            <Link
              to="https://www.instagram.com/paveo_premium_clothings?igsh=eDgwODFtYXhvMnUw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <li>Instagram</li>
            </Link>
            <Link
              to="https://www.facebook.com/PaveoPremiumClothing/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <li>Facebook</li>
            </Link>
          </ul>
          <div className="flex items-center justify-center space-x-3 mt-4 text-lg">
            <Link
              to="https://www.instagram.com/paveo_premium_clothings?igsh=eDgwODFtYXhvMnUw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="hover:scale-105" />
            </Link>
            <Link
              to="https://www.facebook.com/PaveoPremiumClothing/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF className="hover:scale-105" />
            </Link>
          </div>
        </div>

        {/* More Info */}
        <div>
          <h4 className="text-lg font-semibold mb-4">More Info</h4>
          <ul className="space-y-2">
            <li
              onClick={() => navigate("/about-us")}
              className="cursor-pointer"
            >
              About Us
            </li>
            <li
              onClick={() => navigate("/terms-and-conditions")}
              className="cursor-pointer"
            >
              Terms and Conditions
            </li>
            <li
              onClick={() => navigate("/privacy-policy")}
              className="cursor-pointer"
            >
              Privacy Policy
            </li>
            <li>Customer care</li>
            <li
              onClick={() => navigate("/return-and-refund-policy")}
              className="cursor-pointer"
            >
              Return And Refund Policy
            </li>
            <li
              onClick={() => navigate("/latest-news")}
              className="cursor-pointer"
            >
              Latest News
            </li>
          </ul>
        </div>

        {/* Address */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Address</h4>
          <p>paveopune@gmail.com</p>
          <p>9226021650</p>
          {/* <p>Wagholi, Pune, Maharashtra, India - 412207</p> */}

          {userType === "vendor" && (
            <div className="italic text-sm mt-4 text-gray-200 whitespace-nowrap">
              <div>Sales Manager Assigned:</div>

              {salesPerson && salesPerson.first_name ? (
                <>
                  <div>Name: {salesPerson.first_name}</div>
                  <div>Email: {salesPerson.email}</div>
                  <div>Phone: {salesPerson.phone}</div>
                </>
              ) : (
                <div className="text-gray-200">No Sales Manager Assigned</div>
              )}
            </div>
          )}
        </div>

        <div></div>
      </div>

      {/* App Download & Copyright */}
      <div className="mt-10 flex flex-col items-center">
        {/* <h5 className="text-lg font-semibold mb-2">Download The App</h5>
                <img loading='lazy' src="/path/to/google-play-badge.png" alt="Google Play" className="w-32 mb-4" /> */}
        <p className="text-center text-xs">
          &copy; 2025 Paveo Trends Limited . All Right Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
